export default __webpack_public_path__ + "static/the-farmstand-bd7e8eed1acd37726e99fd56541b00c0.png";